import { StandardEvents } from '@shopify/events';

const notice = document.querySelector('[data-vr-cart-next]');
if (notice) {
  const status = notice.querySelector('[data-vr-cart-next-status]');
  const delivery = notice.querySelector('[data-vr-cart-next-delivery]');
  const shippingDiscount = notice.querySelector('[data-vr-cart-next-discount]');
  let latestOperation = 0;

  function hide() {
    notice.hidden = true;
    document.body.classList.remove('vr-cart-next-visible');
    status.textContent = '';
    delivery.replaceChildren();
    shippingDiscount.disabled = true;
  }

  function dismiss() {
    latestOperation++;
    hide();
  }

  function cartIsOpen() {
    return Boolean(document.querySelector('theme-drawer[open] cart-drawer-component'));
  }

  function deliverySummary(html) {
    if (typeof html !== 'string') return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector('[data-vr-delivery-summary]');
  }

  notice.querySelector('[data-vr-cart-next-close]').addEventListener('click', dismiss);
  window.addEventListener('pageshow', dismiss);
  document.addEventListener('theme-drawer:open', event => {
    if (event.target.querySelector?.('cart-drawer-component')) dismiss();
  });

  document.addEventListener(StandardEvents.cartLinesUpdate, async event => {
    const operation = ++latestOperation;
    hide();
    // The native event precedes the request. Only confirm a successful addition.
    if (event.action !== 'add' || !event.promise) return;
    try {
      const result = await event.promise;
      if (operation !== latestOperation || result.detail?.didError !== false) return;
      if (!window.matchMedia('(max-width: 749px)').matches || cartIsOpen()) return;
      notice.hidden = false;
      document.body.classList.add('vr-cart-next-visible');
      status.textContent = 'Added to your basket';

      // Reuse Shopify's freshly rendered totals, including discounts and delivery.
      let summary = Object.values(result.detail.sections || {}).map(deliverySummary).find(Boolean);
      if (!summary) {
        const url = new URL(notice.dataset.cartUrl, window.location.origin);
        url.searchParams.set('section_id', 'cart-drawer-section');
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) return;
        summary = deliverySummary(await response.text());
      }
      if (operation !== latestOperation || !summary || notice.hidden) return;
      delivery.replaceChildren(summary);
      shippingDiscount.disabled = !summary.hasAttribute('data-vr-free-shipping');
    } catch {
      // Product forms own add errors. A totals fetch failure leaves the basket link usable.
    }
  });
}
